import { createApiRef } from '@backstage/core-plugin-api';
import {
  Method,

  initProxy,
} from '@internal/plugin-components-react/src/api/proxyApi';
import { PROXY_TARGETS } from '@internal/plugin-components-react/src/utils/types';








/**
 * ApiRef for the AnnouncementAPI.
 *
 * @public
 */
export const AnnouncementAPIRef = createApiRef({
  id: 'plugin.announcement.api',
});

/**
 * Options for creating a todo client.
 *
 * @public
 */




/**
 * An implementation of the AgentApi that talks to the agent plugin backend.
 *
 * @public
 */
export class AnnouncementClient  {
  statusPageProxy;
  method = { method: Method.GET };

  constructor(options) {
    this.statusPageProxy = initProxy(
      PROXY_TARGETS.STATUSPAGE,
      options.discoveryApi,
    );
  }

  async getAnnouncements(tenant, pageParams) {
    const { Environment, Client } = tenant;
    const { offset, limit } = pageParams;
    try {
      const response = await this.statusPageProxy.fetchApi(
        `announcements?offset=${offset}&limit=${limit}`,
        {
          method: Method.GET,
          headers: {
            Client,
            Environment,
          },
        },
      );
      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async updateAnnouncement(payload, tenant) {
    const stringifiedData = JSON.stringify(payload);
    const { Environment, Client } = tenant;
    const { id } = payload;
    let endpoint = `announcements/${id}`;
    try {
      const response = await this.statusPageProxy.fetchApi(endpoint, {
        method: Method.PATCH,
        body: stringifiedData,
        headers: {
          Client,
          Environment,
        },
      });
      const { data } = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async sendAnnouncement(payload, tenants) {
    const stringifiedData = JSON.stringify({ announcement: payload, tenants });
    let endpoint = 'announcements/bulk';
    try {
      const response = await this.statusPageProxy.fetchApi(endpoint, {
        method: Method.POST,
        body: stringifiedData,
      });
      const { data } = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async deleteAnnouncement(id, tenant) {
    const { Environment, Client } = tenant;
    try {
      const response = await this.statusPageProxy.fetchApi(
        `announcements/${id}`,
        {
          method: Method.DELETE,
          headers: {
            Client,
            Environment,
          },
        },
      );
      const { data } = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getTenants() {
    try {
      const response = await this.statusPageProxy.fetchApi(`tenants`, {
        method: Method.GET,
      });
      const tenants = await response.json();
      return tenants;
    } catch (error) {
      throw error;
    }
  }

  async getEmailStatus(
    offset,
    announcement_id,
    tenant,
  ) {
    const { Environment, Client } = tenant;
    try {
      const response = await this.statusPageProxy.fetchApi(
        `announcements/email-status?limit=100&offset=${offset}&announcement_id=${announcement_id}`,
        {
          method: Method.GET,
          headers: {
            Client,
            Environment,
          },
        },
      );
      const tenants = await response.json();
      return tenants;
    } catch (error) {
      throw error;
    }
  }
}
